module.exports = __webpack_public_path__ + "static/media/applications-permits-laser-alerts.f802c423.svg";